<!-- Cookie Consent Floating Banner -->
<div *ngIf="isVisible" class="cookie-banner-wrapper">
  <div class="cookie-banner-card">
    <div class="cookie-banner-header">
      <div class="cookie-icon-box">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5Z"/>
          <path d="M8.5 8.5v.01"/>
          <path d="M16 15.5v.01"/>
          <path d="M12 12v.01"/>
          <path d="M11 17v.01"/>
          <path d="M7 14v.01"/>
        </svg>
      </div>
      <div class="cookie-title-area">
        <h4>{{ getText('CookieConsentTitle') }}</h4>
        <span class="cookie-badge">{{ getText('CookieConsentBadge') }}</span>
      </div>
    </div>

    <div class="cookie-banner-body">
      <p [innerHTML]="getText('CookieConsentBannerText')"></p>
    </div>

    <div class="cookie-banner-actions">
      <button type="button" class="btn-cookie btn-cookie-primary" (click)="acceptAll()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ getText('CookieConsentAcceptAll') }}
      </button>

      <button type="button" class="btn-cookie btn-cookie-secondary" (click)="acceptNecessary()">
        {{ getText('CookieConsentNecessaryOnly') }}
      </button>

      <button type="button" class="btn-cookie btn-cookie-link" (click)="openPreferences()">
        {{ getText('CookieConsentCustomize') }}
      </button>
    </div>
  </div>
</div>

<!-- Preferences Customization Modal -->
<div *ngIf="showPreferencesModal" class="cookie-modal-backdrop" (click)="closePreferences()">
  <div class="cookie-modal-card" (click)="$event.stopPropagation()">
    <div class="cookie-modal-header">
      <div>
        <h3>{{ getText('CookieConsentModalTitle') }}</h3>
        <p class="cookie-modal-subtitle">{{ getText('CookieConsentModalSubtitle') }}</p>
      </div>
      <button type="button" class="cookie-modal-close" (click)="closePreferences()">
        &times;
      </button>
    </div>

    <div class="cookie-modal-body">
      <!-- Essential Cookies -->
      <div class="cookie-preference-item">
        <div class="preference-info">
          <div class="preference-title-row">
            <strong>{{ getText('CookieConsentNecessaryTitle') }}</strong>
            <span class="badge-always-active">{{ getText('CookieConsentAlwaysActive') }}</span>
          </div>
          <p>
            {{ getText('CookieConsentNecessaryDesc') }}
          </p>
        </div>
        <div class="preference-toggle">
          <label class="toggle-switch disabled">
            <input type="checkbox" [checked]="true" disabled />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>

      <!-- Analytics Cookies -->
      <div class="cookie-preference-item">
        <div class="preference-info">
          <div class="preference-title-row">
            <strong>{{ getText('CookieConsentAnalyticsTitle') }}</strong>
          </div>
          <p>
            {{ getText('CookieConsentAnalyticsDesc') }}
          </p>
        </div>
        <div class="preference-toggle">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="analytics" />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>

      <!-- Functional Cookies -->
      <div class="cookie-preference-item">
        <div class="preference-info">
          <div class="preference-title-row">
            <strong>{{ getText('CookieConsentFunctionalTitle') }}</strong>
          </div>
          <p>
            {{ getText('CookieConsentFunctionalDesc') }}
          </p>
        </div>
        <div class="preference-toggle">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="functional" />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="cookie-modal-footer">
      <button type="button" class="btn-cookie btn-cookie-secondary" (click)="acceptNecessary()">
        {{ getText('CookieConsentRejectOptional') }}
      </button>

      <button type="button" class="btn-cookie btn-cookie-primary" (click)="saveCustomPreferences()">
        {{ getText('CookieConsentSavePreferences') }}
      </button>
    </div>
  </div>
</div>
